import { useEffect, useState } from 'react';

import { screensMap } from '..';
import UserLogin from '@/views/Landing/UserLogin';
import HeroSection from '@/views/Landing/HeroSection';
import { useGlobalStore } from '@/store';
import { setCustomerAccessToken, shouldListenForMessage } from '@/utils/helpers';
import { PaymentCancelWrapper } from '@/shared/Components/PaymentCancelWrapper';
import { fetchCustomerAuthToken } from '@/api/login';
import { trackHelper } from '@/analytics/utils';
import { ANALYTICS_ACTIONS, EVENT_NAMES } from '@/analytics/constants';

const Landing: React.FC = () => {
  const { setUserAccessToken, paymentDetails, setMerchantKey, userAccessToken } = useGlobalStore();
  const { error, loading } = paymentDetails;

  const [showErrorModal, setShowError] = useState(false);

  useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
    if (window.parent) {
      // Send message to parent window
      window.parent.postMessage(
        {
          message: 'iframe-ready',
        },
        '*',
      );

      // eslint-disable-next-line func-names
      window.addEventListener('message', function (event) {
        // Handle message from parent
        if (shouldListenForMessage(event, window)) {
          setMerchantKey(event.data.key as string);
          // If customer token is received user is already logged in
          if (event.data.token) {
            setUserAccessToken(event.data.token as string);
            setCustomerAccessToken(event.data.token as string, (token) => {
              setUserAccessToken(token);
            });
          } else {
            // make a call to get the refresh token
            fetchCustomerAuthToken('')
              .then((res) => {
                if (res.success && res.headers.xCustomerToken) {
                  // update the headers
                  // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                  setUserAccessToken(res.headers.xCustomerToken);
                }
              })
              .catch(() => {
                setUserAccessToken('');
              });
          }
        } else {
          // make a call to get the refresh token
          fetchCustomerAuthToken('')
            .then((res) => {
              if (res.success && res.headers.xCustomerToken) {
                // update the headers
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                setUserAccessToken(res.headers.xCustomerToken);
              }
            })
            .catch(() => {
              setUserAccessToken('');
            });
        }
      });
    } else {
      console.error('Parent window not found');
    }
  }, []);

  useEffect(() => {
    if (error) {
      setShowError(true);
      // Track Error popup render
      trackHelper({
        actionName: ANALYTICS_ACTIONS.RENDER,
        objectName: EVENT_NAMES.FAILED_TO_CONTINUE,
        screen: screensMap.LANDING,
      });
    }
  }, [error]);

  return (
    <>
      <HeroSection />
      <UserLogin />
      {!loading && error ? (
        <PaymentCancelWrapper
          isOpen={showErrorModal}
          onDismiss={(): void => {
            setShowError(false);
          }}
          isCloseable={false}
          ctaText="Change payment method"
          title="Failed to continue"
          description={`${error}. You can retry with a different payment option`}
        />
      ) : null}
    </>
  );
};

export default Landing;
